<template>
  <div class="week-selector row">
    <div class="col-2 justify-content-start">
      <ActionButton
        class-name="btn-no-style"
        @click="prevWeek">
        <i class="fas fa-chevron-left"/>
      </ActionButton>
    </div>
    <div class="col font-weight-bold non-selectable-text">{{ getWeekDateString }}</div>
    <div class="col-2 justify-content-end">
      <ActionButton
        class-name="btn-no-style"
        @click="nextWeek">
        <i class="fas fa-chevron-right"/>
      </ActionButton>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import ActionButton from '@/components/Actions/ActionButton';

export default {
  name: 'WeekSelector',
  components: {
    ActionButton,
  },
  data() {
    return {
      selectedWeek: moment().week(),
    };
  },
  computed: {
    getWeekDateString() {
      if (this.$i18n.locale === 'fr') {
        return this.getFrenchWeekDateString;
      }
      return this.getEnglishWeekDateString;
    },
    getFrenchWeekDateString() {
      return (
        `${this.getDayOfTheWeek(0)
        } ${
          this.getDayWeekMonth(0)
        } ${
          this.getDayWeekYear(0)
        } au ${
          this.getDayOfTheWeek(6)
        } ${
          this.getDayWeekMonth(6)
        } ${
          this.getDayWeekYear(6)}`
      );
    },
    getEnglishWeekDateString() {
      return (
        `${this.getDayOfTheWeek(0)
        } ${
          this.getDayWeekMonth(0)
        } ${
          this.getDayWeekYear(0)
        } to ${
          this.getDayOfTheWeek(6)
        } ${
          this.getDayWeekMonth(6)
        } ${
          this.getDayWeekYear(6)}`
      );
    },
  },
  updated() {
    this.$emit('renderChanged');
  },
  methods: {
    nextWeek() {
      this.selectedWeek += 1;
      this.$emit('change', this.selectedWeek);
      this.$emit('input', this.selectedWeek);
    },
    prevWeek() {
      this.selectedWeek -= 1;
      this.$emit('change', this.selectedWeek);
      this.$emit('input', this.selectedWeek);
    },
    getDayOfTheWeek(day) {
      return moment()
        .week(this.selectedWeek)
        .day(day)
        .format('D');
    },
    getDayWeekYear(day) {
      return moment()
        .week(this.selectedWeek)
        .day(day)
        .format('YYYY');
    },
    getDayWeekMonth(day) {
      return moment()
        .week(this.selectedWeek)
        .day(day)
        .format('MMM');
    },
  },
};
</script>

<style scoped lang="scss">
i {
  color: $secondary;
  font-size: 30px;
}

div {
  &.week-selector {
    padding: 8px 0;
    & > div {
      color: $base;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    i {
      display: flex;
    }
  }
}
.fa-chevron-right,
.fa-chevron-left {
  cursor: pointer;
}
</style>
